import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 */

export const sendAPBMailApi = async (
  osdId: string | undefined,
  params: any = {},
  headers: Record<string, string> = {},
) => {
  try {
    const staticHeaders = getTrackingHeadersMap(ApiType.SEND_APB_MAIL) || {};
    const defaultHeaders = {
      ...staticHeaders,
      "OSD-Exception-Number": osdId,
    };
    const response = await axios.post(
      getUrl(ApiType.SEND_APB_MAIL).replace(":osdId", osdId ?? ""),
      params,
      { headers: { ...defaultHeaders, ...headers } },
    );
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.sendAPBMail, {
      badRequestOrder: "errorsFirst",
    });
  }
};
